import intl from 'react-intl-universal';
import { enGB as en, nb, sv, Locale } from 'date-fns/locale';

import enTranslations from '../assets/locale/en.json';
import nbTranslations from '../assets/locale/nb.json';
import svTranslations from '../assets/locale/sv.json';

export const enLocale = 'en-GB';
export const nbLocale = 'nb-NO';
export const svLocale = 'sv-SE';

const incorrectNorwegianLocale = 'no-NB';

const translationsMapping: { [code: string]: any } = {
  [enLocale]: enTranslations,
  [nbLocale]: nbTranslations,
  [svLocale]: svTranslations,
};

export const supportedLocales: { name: string; value: string }[] = [
  { name: 'English', value: enLocale },
  { name: 'Norwegian', value: nbLocale },
  { name: 'Swedish', value: svLocale },
];

const localeMapping: { [code: string]: Locale } = {
  [enLocale]: en,
  [nbLocale]: nb,
  [svLocale]: sv,
};

export const getTranslations = (locale: string) => translationsMapping[locale] || enTranslations;

export const getLocale = (locale?: string) => (locale && localeMapping[locale]) || en;

export const getCurrentLocale = () => getLocale(intl.getInitOptions().currentLocale);

export const convert = (locale: string): string => {
  let localeCode = locale.replace('_', '-');

  if (incorrectNorwegianLocale === localeCode) {
    localeCode = nbLocale;
  }

  return supportedLocales.find(({ value }) => value === localeCode) ? localeCode : enLocale;
};
